import {
  Box,
  Button,
  Flex,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
} from "@chakra-ui/react";
import ProviderPref from "./ProviderPref/ProviderPref";
import Stations from "./Stations/Stations";
import { useHasPermission } from "../../common/PermissionsFunction/permissiosnFunction";
import { useState } from "react";
import CitiesTable from "../CitiesTable";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";

type props = {
  cityId: string;
  cityCode: string;
};

export default function SettingSection({
  cityId,
  cityCode,
}: props): JSX.Element {
  const [activePage, setActivePage] = useState("1");

  const canViewProviders = useHasPermission("canViewProviders");
  const canViewStations = useHasPermission("canViewStations");
  const handleBackButton = () => {
    setActivePage("2");
  };

  return (
    <>
      {activePage === "1" && (
        <Box
          p={5}
          rounded={"lg"}
          bg={"white"}
          shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
          h={"100%"}
        >
          <Flex justify={"start"} gap={2} mb={2}>
            <Tooltip label="Back to Cities" hasArrow>
              <Button
                onClick={() => {
                  handleBackButton();
                }}
                colorScheme="teal"
                aria-label="back to cities"
                leftIcon={<MdKeyboardDoubleArrowLeft />}
              >
                Back
              </Button>
            </Tooltip>
          </Flex>

          <Tabs colorScheme="teal">
            <TabList gap={4}>
              {canViewProviders && <Tab fontWeight={500}>Providers</Tab>}
              {canViewStations && <Tab fontWeight={500}>Stations</Tab>}
              {/* <Tab fontWeight={500}>Three</Tab> */}
            </TabList>
            <TabIndicator
              mt="-1.5px"
              height="2px"
              bg="teal.500"
              borderRadius="1px"
            />
            <TabPanels>
              <TabPanel px={0}>
                {canViewProviders && (
                  <ProviderPref cityId={cityId} CityCode={cityCode} />
                )}
              </TabPanel>
              <TabPanel px={0}>
                {canViewStations && <Stations cityId={cityId} cityCode={cityCode} />}
              </TabPanel>
              {/* <TabPanel>
            <p>three!</p>
          </TabPanel> */}
            </TabPanels>
          </Tabs>
        </Box>
      )}
      {activePage === "2" && <CitiesTable />}
    </>
  );
}
